import { useState } from 'react'
import './Menu.css'

const Menu = () => {
  const [categories] = useState(['All', 'Starters', 'Main Course', 'Desserts', 'Beverages'])
  const [selectedCategory, setSelectedCategory] = useState('All')
  const [items] = useState([])

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>QR Menu</h1>
          <p className="page-subtitle">Browse our digital menu and place your order</p>
        </div>
      </div>

      <div className="menu-categories">
        {categories.map(category => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {items.length === 0 ? (
        <div className="card">
          <div className="empty-state">
            <p>Menu items coming soon</p>
            <p className="empty-state-subtitle">Our menu will be available here shortly</p>
          </div>
        </div>
      ) : (
        <div className="menu-items">
          {/* Menu items will be displayed here */}
        </div>
      )}
    </div>
  )
}

export default Menu


